const isValidUrl = (url: string): boolean => {
  // Quick check for http or https scheme + space
  const urlPattern = /^(https?:\/\/)/i;
  if (!urlPattern.test(url)) return false;

  const suspiciousPatterns: RegExp[] = [
    // Avoid userinfo in URLs
    /@/,
    // Encoded characters
    /%[0-9a-f]{2}/i,
    // Script tags
    /<script.*?>.*?<\/script>/i,
    // Localhost
    /localhost/i,
    // Loopback IPs
    /127\.0\.0\.1/,
    // Private IPs
    /\b(?:10|172\.(?:1[6-9]|2\d|3[0-1])|192\.168)\.\d{1,3}\.\d{1,3}/,
  ];

  const hasSuspiciousPattern = suspiciousPatterns.some(pattern =>
    pattern.test(url),
  );
  if (hasSuspiciousPattern) return false;

  try {
    // Deep check for domain, optional port, path, query, and fragment.
    const parsed = url.match(
      /^https?:\/\/([^/:?#]+)(:\d+)?(\/[^?#]*)?(\?[^#]*)?(#.*)?$/i,
    );
    return parsed !== null;
  } catch {
    return false;
  }
};

export default isValidUrl;
